<div class="d-flex flex-column">
  <form class="mt-2">
    <input
      #search
      (blur)="searchChanged($event)"
      class="text-field search-text-field"
      [class.disabled]="disabled"
      id="searchBar"
      name="searchBar"
      [disabled]="disabled"
      placeholder="{{ placeholder }}"
      inputmode="numeric"
      type="number" />
  </form>
</div>
